import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { BranchProvider, useBranch } from "./context/BranchContext";
import { CompareProvider } from "./context/CompareContext";
import { LayoutProvider } from "./context/LayoutContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { SearchProvider } from "./context/SearchContext";
import CartDrawer from "./components/feature/CartDrawer";
import CompareBar from "./components/feature/CompareBar";
import PromoBar from "./components/feature/PromoBar";
import WhatsAppPopup from "./components/feature/WhatsAppPopup";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";
import GamingMascot from "./pages/home/components/GamingMascot";
import ScrollToTop from "./components/feature/ScrollToTop";
import LoadingScreen from "./components/feature/LoadingScreen";
import GlobalSearch from "./components/feature/GlobalSearch";
import StagingBadge from "./components/feature/StagingBadge";
import { useState } from "react";

/**
 * Las páginas se vuelven a montar al cambiar de sucursal: cada una pide su catálogo al
 * montarse, y el catálogo ahora va filtrado por la sucursal elegida (`?branchIds=`).
 * La ficha no: muestra todas las sucursales visibles y el selector de su página solo
 * cambia de cuál se compra, así que remontarla perdería la cantidad elegida.
 */
function BranchScopedRoutes() {
  const { branch } = useBranch();
  const { pathname } = useLocation();
  return <AppRoutes key={pathname.startsWith("/products/") ? "detail" : branch.key} />;
}

function App() {
  const [showLoader, setShowLoader] = useState(() => {
    if (typeof sessionStorage !== 'undefined') {
      const seen = sessionStorage.getItem('spartech_loaded');
      if (seen) return false;
    }
    return true;
  });

  const handleLoaderComplete = () => {
    sessionStorage.setItem('spartech_loaded', '1');
    setShowLoader(false);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <LanguageProvider>
          <LayoutProvider>
            <CompareProvider>
              <BranchProvider>
              <CartProvider>
                <SearchProvider>
                  {showLoader && <LoadingScreen onComplete={handleLoaderComplete} />}
                  <BrowserRouter basename={__BASE_PATH__}>
                    <GlobalSearch />
                    <StagingBadge />
                    <PromoBar />
                    <BranchScopedRoutes />
                    <CartDrawer />
                    <CompareBar />
                    <WhatsAppPopup />
                    <FloatingWhatsApp />
                    <GamingMascot />
                    <ScrollToTop />
                  </BrowserRouter>
                </SearchProvider>
              </CartProvider>
              </BranchProvider>
            </CompareProvider>
          </LayoutProvider>
        </LanguageProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;